import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { setDocumentBase } from "@/hooks/useDocumentTitle";

const BrandingContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export const resolveAssetUrl = (url) => (url && url.startsWith("/") ? `${API}${url}` : url || "");

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/api/public/branding`);
      setBranding(data);
      setDocumentBase(data.company_name ? `${data.company_name} CRM` : "CRM");
      if (data.brand_color) document.documentElement.style.setProperty("--brand", data.brand_color);
    } catch (err) {
      setBranding({ setup_complete: true, company_name: "", short_name: "", lms_name: "Learning Portal", lms_short_name: "LMS", brand_color: "#0F172A" });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <BrandingContext.Provider value={{ branding, refresh }}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  return { ...(ctx?.branding || {}), loaded: !!ctx?.branding, refresh: ctx?.refresh };
}
